import React from "react";
import { cn } from "../../lib/cn";

export interface VersionChipProps {
  label: string;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

/** claudesign version chip (quiet metadata). Mirrors `.vchip`
 *  from docs/redesign/ommuse-theme.css. */
export const VersionChip: React.FC<VersionChipProps> = ({
  label,
  active,
  onClick,
  className,
}) => {
  const classes = cn(
    "inline-flex items-center font-sans text-[12px] font-semibold leading-none",
    "px-[10px] py-[6px] rounded-[7px] shadow-edge-hi",
    active
      ? "border border-cyan text-white bg-[var(--accent-soft)]"
      : "border border-border text-muted bg-surface-2",
    onClick ? "cursor-pointer" : "cursor-default",
    className,
  );
  return onClick ? (
    <button type="button" onClick={onClick} className={classes}>
      {label}
    </button>
  ) : (
    <span className={classes}>{label}</span>
  );
};

export default VersionChip;
